import { render, staticRenderFns } from "./SubmitButtons.vue?vue&type=template&id=3c9871a5&scoped=true&"
import script from "./SubmitButtons.vue?vue&type=script&lang=js&"
export * from "./SubmitButtons.vue?vue&type=script&lang=js&"
import style0 from "./SubmitButtons.vue?vue&type=style&index=0&id=3c9871a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9871a5",
  null
  
)

export default component.exports